import {
  STOCK_MASSIVE_UPLOAD_SAVE_STEP_BEGIN,
  STOCK_MASSIVE_UPLOAD_SAVE_STEP_SUCCESS,
  STOCK_MASSIVE_UPLOAD_SAVE_STEP_FAILURE,
  STOCK_MASSIVE_UPLOAD_SAVE_STEP_DISMISS_ERROR
} from './constants'

import { BFFAgent } from '../../../common/BFFAgent';

export function saveStep (step) {
    return (dispatch) => { // optionally you can have getState as the second argument
        dispatch({
          type: STOCK_MASSIVE_UPLOAD_SAVE_STEP_BEGIN,
        });
        
        const doRequest = BFFAgent.Catalogs.saveStep(step)
        doRequest.then(
          (res) => {
            dispatch({
              type: STOCK_MASSIVE_UPLOAD_SAVE_STEP_SUCCESS,
              data: res.data,
            });
            },
            // Use rejectHandler as the second argument so that render errors won't be caught.
            (err) => {
              dispatch({
                type: STOCK_MASSIVE_UPLOAD_SAVE_STEP_FAILURE,
                data: { error: err },
              });
            },
          );
      };
}
export function dismissSaveStep(){
    return {
        type: STOCK_MASSIVE_UPLOAD_SAVE_STEP_DISMISS_ERROR,
      };
}

export function reducer(state, action) {
    switch (action.type) {
      case STOCK_MASSIVE_UPLOAD_SAVE_STEP_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          saveStepPending: true,
          saveStepError: null,
        };
  
      case STOCK_MASSIVE_UPLOAD_SAVE_STEP_SUCCESS:
        // The request is success
        return {
          ...state,
          saveStepPending: false,
          saveStepError: null,
        };
  
      case STOCK_MASSIVE_UPLOAD_SAVE_STEP_FAILURE:
        // The request is failed
        return {
          ...state,
          saveStepPending: false,
          saveStepError: action.data.error,
        };
  
      case STOCK_MASSIVE_UPLOAD_SAVE_STEP_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          saveStepError: null,
        };
  
      default:
        return state;
    }
  }